// src/shared/ui/Input.jsx — promoted from adai/components/ui/Input.jsx (already
// a clean forwardRef primitive compatible with react-hook-form; every other
// module previously wrote its own plain <input> instead of reusing this).
import { forwardRef } from "react";
import "./formControls.css";

const Input = forwardRef(({ type = "text", className = "", ...props }, ref) => (
  <input type={type} className={`shui-input adai-form-input ${className}`.trim()} ref={ref} {...props} />
));

Input.displayName = "Input";

export default Input;
